import styled from '@emotion/styled';

const BenefitTable = styled.table`
  width: ${props => props.width || '100%'};
  padding-bottom: 1em;
  font-family: ${props => props.theme.fontFamily};
  line-height: 1.42857143;
  table-layout: fixed;
`;
export default BenefitTable;

export const BenefitTh = styled.th`
  background-color: ${props => (props.isDragging ? props.theme.backgroundColor_themePrimary_hover : props.theme.backgroundColor_themePrimary)};
  color: ${props => props.theme.color_themePrimary};
  font-size: ${props => props.theme.fontSize_base};
  text-align: left;
  padding: 10px;
  width: ${props => props.columnWidth || 'auto'};
  &:hover {
    background-color: ${props => (props.editAvailable ? props.theme.backgroundColor_themePrimary_hover : props.theme.backgroundColor_themePrimary)}
  }
  word-wrap: break-word;
`;

export const BenefitTr = styled.tr`
  /* Maintain cell widths while dragging */
  display: ${props => (props.isDragging ? 'table' : 'table-row')};
  &:nth-of-type(even) {
    background-color: ${props => props.theme.backgroundColor_page};
  }
  &:nth-of-type(odd) {
    background-color: ${props => props.theme.backgroundColor};
  }
`;

export const BenefitTd = styled.td`
  cursor: text;
  &:hover {
    background-color: ${props => (props.editAvailable ? props.theme.borderColor : 'inherit')}
  }
  font-size: ${props => props.theme.fontSize_base};
  color: ${props => props.theme.color};
  padding: 10px;
  width: ${props => (props.columnWidth ? props.columnWidth : 'auto')};
  word-wrap: break-word;
`;

export const Legend = styled.legend`
  display: block;
  width: 100%;
  padding: 0px;
  margin-bottom: 20px;
  font-size: 21px;
  border-bottom: 3px solid ${props => props.theme.backgroundColor_themePrimary};
  font-family: ${props => props.theme.fontFamily};
  &:hover {
    background-color: ${props => (props.editAvailable ? props.theme.borderColor : 'inherit')}
  }
  word-wrap: break-word;
  min-height: 2em;
`;
